<template>
  <div>
    <!-- loading -->
    <loading v-if="loading === 1" style="min-height:620px;"></loading>
    <div v-show="loading === 0">
      <div class="main-content" v-if="evaluate_result.abilities && evaluate_result.abilities.length > 0">
        <h2 class="m-b-sm">
          <span v-if="questionnaire.category === 2">岗位</span>测评报告
          <span class="btn btn-primary right" @click="download()" v-if="questionnaire.category === 2">下载报告</span>
        </h2>
        <div class="b-b"></div>
        <div id="report-area" class="row">
          <div class="col-xs-12">
            <div class="row">
              <div class="col-xs-12 m-t-b-sm">
                <div style="height:20px;background:#42b983;"></div>
              </div>
              <div class="col-xs-12">
                <div class="row">
                  <div class="col-xs-6">
                    <img src="/assets/images/psych2_4_2.jpg" alt="" class="psych-logo left" height="60">
                  </div>
                  <div class="col-xs-6">
                    <img src="/assets/images/lechenggu-logo.png" alt="" class="lechenggu-logo left right" height="60">
                  </div>
                </div>
              </div>
              <h1 class="p-t-b-md n-m-b text-center">{{questionnaire.category === 1 ? '个人': '岗位'}}测评报告</h1>
            </div>
            <div class="row user-info p-b-sm snapshort" v-if="questionnaire.category === 2">
              <div class="col-xs-12">
                <div class="row">
                  <div class="col-xs-6">
                    <div class="line">
                      <span class="label">姓名:</span>
                      <span class="info">{{tester.realname?tester.realname:tester.nickname}}</span>
                    </div>
                    <div class="line">
                      <span class="label">邮箱:</span>
                      <span class="info">{{tester.email}}</span>
                    </div>
                    <div class="line" v-if="tester.phone">
                      <span class="label">手机:</span>
                      <span class="info">{{tester.phone}}</span>
                    </div>
                    <div class="line">
                      <span class="label">岗位:</span>
                      <span class="info">{{questionnaire.alias?questionnaire.alias:questionnaire.name}}</span>
                    </div>
                  </div>
                  <div class="col-xs-6">
                    <img :src="tester.avatar" alt="" width="100" class="m-r-sm right" v-if="tester.avatar">
                  </div>
                </div>
                <div class="b-b m-tb-sm "></div>
              </div>
              <div class="col-xs-12" v-if="evaluate_result.abilities && evaluate_result.abilities.length >= 3">
                <radar style="height:350px;" :title="radar_data.title" :legend="radar_data.legend" :series="radar_data.series" :indicator="radar_data.indicator"></radar>
                <div class="b-b m-b-sm "></div>
              </div>
              <div class="col-xs-12" v-if="evaluate_result.abilities && evaluate_result.abilities.length >= 3">
                <div class="" id="bar-area" style="width:100%;height:300px;"></div>
                <div class="b-b m-b-sm "></div>
              </div>
              <div class="col-xs-12" v-if="questionnaire.category === 2">
                <time-scatter style="height:200px;" :code="code" :type="3" :name="evaluate_result.name" :score="evaluate_result.duration"></time-scatter>
                <div class="b-b m-b-sm "></div>
              </div>
            </div>
            <div class="row" v-show="detail_data === 0">
              <div class="col-xs-12 m-b-sm ability snapshort" :data-index="ind" v-for="(ability,ind) in evaluate_result.abilities" :key="ability._id" :class="{'open': ability.is_open === 1}">
                <div class="btn btn-md n-b-r col-xs-12 n-f btn-success">
                  <div class="row">
                    <div class="col-sm-3 col-xs-12">
                      <span>能力名称：</span>
                      <span class="bold">{{ability.ability.name}}</span>
                    </div>
                  </div>
                </div>
                <div class="detail col-xs-12">
                  <div class="row p-b-sm">
                    <div class="col-xs-12 col-sm-4">
                      <div class="row p-l-r-xs">
                        <div class="desc" v-html="ability.ability.desc"></div>
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-4">
                      <div class="row">
                        <Scatter class="col-xs-12 n-p-l n-p-r" style="height:200px;" :code="code" :type="2" :target="ability.ability._id" :name="ability.ability.name" :score="ability.score" :rate="ability.rate"></Scatter>
                        <div class="col-xs-12 m-t-xs text-center p-b-xs" style="font-size:14px;">
                          <span class="score">{{ability.score.toFixed(2)}}分</span>,领先
                          <span class="score">{{(ability.rate*100).toFixed(2)}}%</span>的{{questionnaire.category === 1 ? '用户' : '求职者'}}</div>
                        <!-- <div class="col-xs-12 m-t-b-xs text-center name">{{ability.ability.name}}</div> -->
                      </div>
                    </div>
                    <div class="col-xs-12 col-sm-4">
                      <div class="row p-b-sm" v-if="ability.grade_desc">
                        <div class="col-xs-12" style="padding-left:5px;">
                          <div class="label">解析：</div>
                          <div class="desc" v-html="ability.grade_desc"></div>
                        </div>
                      </div>
                      <div class="row p-b-sm" v-if="ability.grade_suggestion">
                        <div class="col-xs-12" style="padding-left:5px;">
                          <div class="label">建议：</div>
                          <div class="desc" v-html="ability.grade_suggestion"></div>
                        </div>
                      </div>
                      <div class="row p-b-sm" v-if="ability.grade_improvement">
                        <div class="col-xs-12" style="padding-left:5px;">
                          <div class="label">提升：</div>
                          <div class="desc" v-html="ability.grade_improvement"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="b-b m-b-xs"></div>
                  <div class="row p-b-sm" v-if="ability.indicators.length >=3">
                    <radar class="col-xs-12" style="height:300px;" :title="ability.radar_data.title" :legend="ability.radar_data.legend" :series="ability.radar_data.series" :indicator="ability.radar_data.indicator"></radar>
                  </div>
                  <div class="b-b m-b-xs" v-if="ability.indicators.length >=3"></div>
                  <div class="row p-b-sm">
                    <div class="row">
                      <div class="indicator col-xs-12" :class="{'col-sm-4':ability.indicators.length >= 3,'col-sm-6':ability.indicators.length <=2}" v-for="indicator in ability.indicators" :key="indicator._id">
                        <!-- <svg-circle :length="120" :width="10" :rate="indicator.rate" style="margin:0 auto;" :category="questionnaire.category"></svg-circle> -->
                        <Scatter class="col-xs-12 n-p-l n-p-r" style="height:200px;" :code="code" :type="1" :target="indicator.indicator._id" :name="indicator.indicator.name" :score="indicator.score" :rate="indicator.rate"></Scatter>
                        <time-scatter class="col-xs-12 n-p-l n-p-r" style="height:200px;" :code="code" :type="1" :target="indicator.indicator._id" :name="indicator.indicator.name" :score="indicator.duration" :rate="indicator.rate" v-if="questionnaire.category === 2"></time-scatter>
                        <!-- <div class="col-xs-12 m-t-xs text-center score">{{indicator.score.toFixed(2)}}</div> -->
                        <div class="col-xs-12 m-t-xs text-center p-b-xs" style="font-size:14px;">
                          <span class="score">{{indicator.score.toFixed(2)}}分</span>,领先
                          <span class="score">{{(indicator.rate*100).toFixed(2)}}%</span>的{{questionnaire.category === 1 ? '用户' : '求职者'}}</div>
                        <!-- <div class="col-xs-12 m-t-b-xs text-center name">{{indicator.indicator.name}}</div> -->
                        <div class=" p-t-b-sm" v-if="indicator.grade_desc">
                          <div class="col-xs-12">
                            <div class="row">
                              <div class="label m-b-xs">指标解析：</div>
                              <div class="desc" v-html="indicator.grade_desc"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <h5 class="text-center">
                <span>本报告由</span>
                <a href="http://www.psych.cas.cn" title="中国科学院心理研究所·心理健康应用中心" alt="中国科学院心理研究所·心理健康应用中心" style="color:#000">中国科学院心理研究所·心理健康应用中心</a>
                <span>提供测评技术支持</span>
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Evaluate from "../../../resource/evaluate";

import async from "async";
import H2C from "html2canvas";
import jQuery from "jquery";
import Echarts from "echarts/lib/echarts.js";
import "echarts/lib/chart/bar.js";
import "echarts/lib/component/legend";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import SvgCircle from "../../blocks/svg-circle.vue";
import Radar from "../../blocks/radar.vue";
import Scatter from "../../blocks/scatter.vue";
import TimeScatter from "../../blocks/time-scatter.vue";
import Loading from "../../blocks/loading.vue";
const IDReg = /^[0-9a-f]{24}$/i;
export default {
  name: "EvaluateNormalReportTpl",
  props: {
    code: {
      // 字符串
      type: String,
      required: true,
      validator: v => IDReg.test(v)
    },
    questionnaire: {
      type: Object,
      required: true,
      default: () => ({})
    },
    tester: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data: function() {
    return {
      loading: 1,
      evaluate: {},
      company: {},
      is_mounted: false,
      radar: null,
      bar: null,
      evaluate_result: {
        abilities: []
      },
      detail_data: 0,
      radar_data: {
        title: "",
        legend: [],
        series: [],
        indicator: []
      }
    };
  },
  components: {
    SvgCircle,
    Radar,
    Scatter,
    TimeScatter,
    Loading
  },
  watch: {
    // 监控数据
    "evaluate_result.abilities": function(now) {
      let that = this;
      if (that.is_mounted && now.length >= 3) {
        setTimeout(function() {
          that.buildBar();
          that.buildRadar();
        }, 300);
      }
    }
  },
  created: function() {
    // 页面渲染完成后
    let that = this;
    that.loadReport();
  },
  mounted: function() {
    let that = this;
    that.is_mounted = true;
    if (
      that.evaluate_result &&
      that.evaluate_result.abilities &&
      that.evaluate_result.abilities.length >= 3
    ) {
      setTimeout(function() {
        that.buildBar();
        that.buildRadar();
      }, 300);
    }
  },
  methods: {
    buildRadar: function() {
      let that = this;
      let indicator = [];
      let series = [
        {
          name: "岗位平均分",
          type: "radar",
          tooltip: {
            trigger: "item"
          },
          itemStyle: {
            normal: {
              areaStyle: { type: "default" }
              // color: function(data) {
              //   return "#3399ff";
              // }
            }
          },
          data: [
            {
              value: [],
              name: "岗位平均分"
            }
          ]
        },
        {
          name: "我的得分",
          type: "radar",
          tooltip: {
            trigger: "item"
          },
          itemStyle: {
            normal: {
              areaStyle: { type: "default" },
              color: function(data) {
                return "#00cc99";
              }
            }
          },
          data: [
            {
              value: [],
              name: "我的得分"
            }
          ]
        }
      ];
      that.evaluate_result.abilities.forEach(function(ability) {
        indicator.push({
          name: ability.ability.name,
          max: ability.ability.point_system,
          tips: [
            {
              name: "建议：",
              content: ability.grade_suggestion
            }
          ]
        });
        series[1].data[0].value.push(ability.score);
        series[0].data[0].value.push(
          that.evaluate_result.avarage[ability.ability._id] || 0
        );
        // options.series[1].data[0].value.push(ability.threshold_value)
      });
      that.radar_data.title = "雷达图";
      that.radar_data.legend = ["岗位平均分", "我的得分"];
      that.radar_data.indicator = indicator;
      that.radar_data.series = series;
    },
    buildBar: function() {
      let that = this;
      if (!that.bar) {
        that.bar = Echarts.init(document.querySelector("#bar-area"));
      }
      let options = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: ["能力值"],
          // data: ['能力值', '基础能力值'],
          orient: "vertical",
          right: "20px"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "value",
          max: 100
        },
        yAxis: {
          type: "category",
          axisLabel: {
            textStyle: {
              color: "#000000",
              fontSize: 14,
              fontWeight: "Bold"
            }
          },
          data: []
        },
        series: [
          {
            name: "能力值",
            type: "bar",
            itemStyle: {
              normal: {
                areaStyle: {
                  type: "default"
                },
                color: function(data) {
                  return "#00cc99";
                }
              }
            },
            data: []
          }
        ]
      };
      that.evaluate_result.abilities.forEach(function(ability) {
        options.yAxis.data.push(ability.ability.name);
        options.series[0].data.push(Number(ability.score.toFixed(2)));
      });
      that.bar.setOption(options);
    },
    loadReport: function() {
      let that = this;
      that.$http.get(`/api/v1/evaluate/${that.code}/report`).then(
        res => {
          if (res.status === 200) {
            let data = res.body;
            if (data.code === 0) {
              let report = data.result;
              let indicators = {};
              report.indicators.forEach(indicator => {
                indicator.rate_text = (indicator.rate * 100).toFixed(2) + "%";
                indicator.dasharray =
                  indicator.rate * 314 + " " + (1 - indicator.rate) * 314;
                indicators[indicator.indicator._id] = indicator;
              });

              report.abilities.forEach(ability => {
                let tmpIndicators = [];
                let radar_data = {
                  title: "能力群指标组成",
                  legend: ["指标"],
                  indicator: [],
                  series: [
                    {
                      name: "指标",
                      type: "radar",
                      tooltip: {
                        trigger: "item"
                      },
                      itemStyle: {
                        normal: {
                          areaStyle: { type: "default" },
                          color: function(data) {
                            return "#00cc99";
                          }
                        }
                      },
                      data: [
                        {
                          value: [],
                          name: "指标"
                        }
                      ]
                    }
                  ]
                };
                ability.indicators.forEach((indicator, index, arr) => {
                  var tmp = indicators[indicator.indicator];
                  if (tmp) {
                    for (let p in tmp) {
                      indicator[p] = tmp[p];
                    }
                    radar_data.indicator.push({
                      name: indicator.indicator.name,
                      max: indicator.indicator.point_system
                    });
                    radar_data.series[0].data[0].value.push(indicator.score);
                    tmpIndicators.push(indicator);
                  }
                });
                ability.indicators = tmpIndicators;
                ability.is_open = 1;
                ability.radar_data = radar_data;
              });
              that.evaluate_result = report;
              that.loading = 0;
            } else {
              alert(data.msg);
            }
          } else {
            alert(res.status);
          }
        },
        res => {}
      );
    },
    download: function() {
      const that = this;
      const doc = window.document;
      async.mapLimit(
        doc.querySelectorAll(".snapshort"),
        2,
        (ra, done) => {
          H2C(ra, {
            background: "#fff",
            useCORS: true,
            onrendered: function(canvas) {
              done(null, {
                base64: canvas.toDataURL(),
                height: canvas.height,
                width: canvas.width
              });
            }
          });
        },
        (err, results) => {
          var $form = jQuery(
            '<form method="post" action="/api/base642pdf"></form>'
          );
          $form.append(
            '<textarea style="display:none;" name="base64" >' +
              JSON.stringify(results) +
              "</textarea>"
          );
          $form.append(
            `<input type="hidden" name="name" value="${that.tester.realname}-${
              that.questionnaire.alias
                ? that.questionnaire.alias
                : that.questionnaire.name
            }" />`
          );
          // $form.append(
          //   `<input type="hidden" name="height" value="${canvas.height}" />`
          // );
          // $form.append(
          //   `<input type="hidden" name="width" value="${canvas.width}" />`
          // );
          $form.append(`<input type="hidden" name="category" value="2" />`);
          jQuery(document.body).append($form);
          $form[0].submit();
          $form.remove();
        }
      );
    }
  },
  destroyed: function() {
    let that = this;
    if (that.radar) {
      that.radar.dispose();
      that.radar = null;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
#radar-area {
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// normal.vue?8b5509bc